import { Navigate, Outlet } from 'react-router-dom';
import './styles.css';
import useAuth from '../../hooks/useAuth';

type Props = {
    redirectTo: string;
}

function ProtectedRoutes({redirectTo}: Props){
    const { handleGetToken } = useAuth();
    return handleGetToken() ? <Outlet /> : <Navigate to={redirectTo} />;
}

export default ProtectedRoutes;